import React from 'react';
import PropTypes from 'prop-types';

import CheckboxFilterPanel from './CheckboxFilterPanel';
import questionFilterPanelType from './questionFilterPanelType';
import toStringFilterValue from './toStringFilterValue';
import { merge } from 'lodash';

const withStringValues = toStringFilterValue(({
  fromStringValue: yesnoText => yesnoText.toLowerCase() === 'yes',
  toStringValue: booleanValue => booleanValue ? 'Yes' : 'No'
}));

const withYesNoFilters = (props) =>
  merge(
    {},
    props,
    {
      question: {
        options: ['Yes', 'No'].map(choice => ({
          id: choice.toLowerCase(),
          display: choice
        }))
      }
    });

export const YesNoFilterPanel = props =>
  <CheckboxFilterPanel {...withStringValues(withYesNoFilters(props))} />;

YesNoFilterPanel.defaultProps = {
  value: []
};

YesNoFilterPanel.propTypes = merge({
  value: PropTypes.arrayOf(PropTypes.bool).isRequired
}, questionFilterPanelType);

export default YesNoFilterPanel;
